import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    notices: [],
  },
  getters: {
    getNotices(state) {
      return state.notices
    },
  },
  mutations: {
    SET_NOTICES(state, data) {
      state.notices = data
    },
  },
  actions: {
    notices({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/portal/notices', data)
        .then(response => {
          commit('SET_NOTICES', response.data.data)
        })
        .catch(error => console.error(error))
    },
  },
}
